// @flow
import type { PrismicLinkType } from '~schema';

export default function getLinkedEntryTag(link: ?PrismicLinkType) {
  const document = link && link.document;
  return document && document.__typename === 'PrismicEntryTag'
    ? document
    : undefined;
}
